import AppDatabase from "../database/AppDatabase";
import AppNewsSectionDatabase from "../database/AppNewsSectionDatabase";
import CodeAssesDatabase from "../database/CodeAssesDatabase";
import LearningSiteDatabase from "../database/LearningSiteDatabase";
import MLDatabase from "../database/MLDatabase";
import MartyBlocksDatabase from "../database/MartyBlocksDatabase";
import PythonTranslatorDatabase from "../database/PythonTranslatorDatabase";
import RobotDatabase from "../database/RobotDatabase";
import SensorDashboardDatabase from "../database/SensorDashboardDatabase";
import ServiceProgramDatabase from "../database/ServiceProgramDatabase";
export var DatabaseEnum;
(function (DatabaseEnum) {
    DatabaseEnum["APP"] = "app";
    DatabaseEnum["ROBOT"] = "robot";
    DatabaseEnum["LEARNING_SITE"] = "learning-site";
    DatabaseEnum["PROCESSED_DATA"] = "processed-data";
    DatabaseEnum["SERVICE_PROGRAM"] = "service-program";
    DatabaseEnum["APP_NEWS_SECTION"] = "app-news-section";
    DatabaseEnum["MARTY_BLOCKS"] = "marty-blocks";
    DatabaseEnum["MACHINE_LEARNING"] = "machine-learning";
    DatabaseEnum["PYTHON_TRANSLATOR"] = "python-translator";
    DatabaseEnum["SENSORS_DASHBOARD"] = "sensors-dashboard";
    DatabaseEnum["CODE_ASSES"] = "code-asses";
})(DatabaseEnum || (DatabaseEnum = {}));
function createDatabaseInstance(databaseName, config) {
    if (databaseName === DatabaseEnum.APP) {
        return new AppDatabase(config, databaseName);
    }
    else if (databaseName === DatabaseEnum.ROBOT) {
        return new RobotDatabase(config, databaseName);
    }
    else if (databaseName === DatabaseEnum.LEARNING_SITE) {
        return new LearningSiteDatabase(config, databaseName);
    }
    else if (databaseName === DatabaseEnum.PROCESSED_DATA) {
        return new AppDatabase(config, databaseName);
    }
    else if (databaseName === DatabaseEnum.SERVICE_PROGRAM) {
        return new ServiceProgramDatabase(config, databaseName);
    }
    else if (databaseName === DatabaseEnum.APP_NEWS_SECTION) {
        return new AppNewsSectionDatabase(config, databaseName);
    }
    else if (databaseName === DatabaseEnum.MARTY_BLOCKS) {
        return new MartyBlocksDatabase(config, databaseName);
    }
    else if (databaseName === DatabaseEnum.MACHINE_LEARNING) {
        return new MLDatabase(config, databaseName);
    }
    else if (databaseName === DatabaseEnum.PYTHON_TRANSLATOR) {
        return new PythonTranslatorDatabase(config, databaseName);
    }
    else if (databaseName === DatabaseEnum.SENSORS_DASHBOARD) {
        return new SensorDashboardDatabase(config, databaseName);
    }
    else if (databaseName === DatabaseEnum.CODE_ASSES) {
        return new CodeAssesDatabase(config, databaseName);
    }
    else {
        throw new Error('Invalid database type');
    }
}
export default createDatabaseInstance;
